/**
 * 通用工具函数集合
 * 功能：DOM class 操作（hasClass/addClass/removeClass）、A-Z 排序、字典翻译 setText、HTML 标签剥离
 */
/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}
// 排序A-Z
export function sortAtoZ(array, obj) {
  let value = array.sort(function (s, t) {
    var a = s.toLowerCase();
    var b = t.toLowerCase();
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  })
  let param = {}
  value.forEach(item => {
    for (const key in obj) {
      const element = obj[key];
      if (element == item) {
        let strKey = key + " ";
        param[strKey] = element;
      }
    }
  });
  return param
}
// 循环Object获取对应value
export function setText(num, object) {
  let Str = "";
  for (const key in object) {
    if (object.hasOwnProperty(key)) {
      const element = object[key];
      if (num == key) {
        Str = element
      }

    }
  }
  return Str
}

/** 剥离字符串中的 HTML 标签 */
export function delHtmlTag (str) {
  return str.replace(/<[^>]+>/g, '')
}